// Import HTTP client
import {
  submitKycDetailsStepService,
  getKycDetailsService,
  submitKycDetailsStepFormUploadService,
  submitKycFinalStageService,
  getAttestationDocumentService,
  getKycDisputesService,
  sendEmailVerificationService,
  removeDirectorService
} from '@/services/kycService'

/** mutation types */
const set_kycDetails = 'set_kycDetails'
const set_stepStatus = 'set_stepStatus'
const set_attestationDocument = 'set_attestationDocument'
const set_kycDisputes = 'set_kycDisputes'
const set_verificationEmail = 'set_verificationEmail'

/** state */
const getDefaultState = () => {
  return {
    kycDetails: {},
    stepStatus: [],
    attestationDocumentUrl: null,
    kycDisputes: [],
    verificationEmail: ''
  }
}
const state = getDefaultState()
/** getters */
const getters = {}

/** mutations */
const mutations = {
  [set_kycDetails] (state, data) {
    state.kycDetails = { ...data, ...state.response }
  },
  [set_stepStatus] (state, data) {
    state.stepStatus = data
  },
  [set_attestationDocument] (state, data) {
    state.attestationDocumentUrl = data
  },
  [set_kycDisputes] (state, data) {
    state.kycDisputes = data
  },
  [set_verificationEmail] (state, data) {
    state.verificationEmail = data
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}
/** actions */
const actions = {
  submitKycDetailsStep: ({ commit }, payload) => {
    return submitKycDetailsStepService(payload)
  },
  submitKycDetailsStepFormUpload: ({ commit }, payload) => {
    return submitKycDetailsStepFormUploadService(payload)
  },
  submitKycFinalStage: ({ commit }) => {
    return submitKycFinalStageService()
  },
  getKycDetails: ({ commit }, payload) => {
    return getKycDetailsService(payload).then((response) => {
      commit('set_kycDetails', response.data.data)
      commit('set_stepStatus', response.data.data.stageStatus)
    })
  },
  getKycDisputes: ({ commit }, payload) => {
    return getKycDisputesService(payload).then((response) => {
      commit('set_kycDisputes', response.data.data.disputes)
    })
  },
  getAttestationDocument: ({ commit }, payload) => {
    return getAttestationDocumentService(payload).then((response) => {
      commit('set_attestationDocument', response.data.data)
    })
  },
  setVerificationEmail: ({ commit }, payload) => {
    commit('set_verificationEmail', payload)
  },
  sendEmailVerification: ({ commit }, payload) => {
    return sendEmailVerificationService(payload)
  },
  removeDirector: ({ commit }, payload) => {
    return removeDirectorService(payload)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
